import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialerModule } from 'dialer';
import { DialerClientConfigComponent } from './dialer-client-config/dialer-client-config.component';
import { DialerClientMonitorComponent } from './dialer-client-monitor/dialer-client-monitor.component'
import { DialerClientConnectionComponent } from './dialer-client-connection/dialer-client-connection.component'
import { DialerClientTestSeqComponent } from './dialer-client-testseq/dialer-client-testseq.component'
import { DialerClientTestSeqModalComponent } from './dialer-client-testseq/dialer-client-testseq-modal/dialer-client-testseq-modal.component'
import { DialerClientIssueModalComponent } from './dialer-client-issue-modal/dialer-client-issue-modal.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { NgPipesModule } from 'ngx-pipes';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { DialerClientResultCallsTableComponent } from './dialer-client-result-calls-table/dialer-client-result-calls-table.component'
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { DragDropModule } from '@angular/cdk/drag-drop';

@NgModule({
  declarations: [
    DialerClientConfigComponent,
    DialerClientMonitorComponent,
    DialerClientConnectionComponent,
    DialerClientTestSeqComponent,
    DialerClientTestSeqModalComponent,
    DialerClientResultCallsTableComponent,
    DialerClientIssueModalComponent
  ],
  imports: [
    CommonModule,
    DialerModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgPipesModule,
    DragDropModule,
    TabsModule.forRoot(),
    BsDropdownModule.forRoot()
  ],
  exports: [
    DialerClientConfigComponent,
    DialerClientMonitorComponent,
    DialerClientConnectionComponent,
    DialerClientTestSeqComponent,
    DialerClientTestSeqModalComponent,
    DialerClientResultCallsTableComponent,
    DialerClientIssueModalComponent
  ]
})
export class DialerClientModule {}
